import TrendService from "@/pages/common/trend/service/TrendService";
import TrendActions from "./TrendActions";
import TrendMutations from "./TrendMutations";
import TrendMenu from "./trendMenu/TrendMenuModule";

const state = TrendService.FactoryEmptyTrendState();

const { actions } = TrendActions;

const { mutations } = TrendMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
	modules: { TrendMenu }
};